import DispatchConstants from '../../constants/DispatchConstants';

import Properties from '../../model/Properties';

const initialProperties = Properties();

const initState = () => ({
  statsDaysBack: 0,
  restrictions: {},
  listingAliases: [],
  hasSubNavFiltersBeenTouched: false,
  ...initialProperties,
});

const properties = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_PROPERTIES: {
      const { listingsModel } = payload;
      const listingAliases = listingsModel.listings.map((listing) => listing.listingAlias);

      return Object.assign({}, state, listingsModel, { listingAliases });
    }
    case DispatchConstants.UPDATE_SUB_NAV_FILTERS_TOUCHED:
      return { ...state, hasSubNavFiltersBeenTouched: payload };

    default:
      return state;
  }
};

export default properties;
